/* eslint-disable @angular-eslint/prefer-inject */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Injector, OnInit } from '@angular/core';
import { assets } from '../../core/constants/assets.const';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { BaseClass } from '../class/BaseClass';
import { LoginResponse } from '../../models/auth.model';
import { signal } from '@angular/core';
import { ROLES } from '../../core/constants/keys.const';
import { UserType } from '../../service/user-type.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

interface FooterItem {
  label: string;
  routerLink?: string;
  command?: () => void;
}

interface FooterSection {
  title: string;
  items: FooterItem[];
}

@Component({
    selector: 'notchmark-footer',
    imports: [ButtonModule, RouterModule, CommonModule, FormsModule, InputTextModule],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent extends BaseClass implements OnInit {
  assetsConst = assets;

   public _userType: UserType | null = null;
  logoLink = '/';
  protected profile = signal<LoginResponse | null>(null);
  activeIndex: number | null = null;
  footerSections: FooterSection[] = [
    {
      title: 'Quick Links',
      items: [
        { label: 'Withdraw', routerLink: '/withdraw' },
        { label: 'About Us', routerLink: '/about-us' },
        { label: 'Blog', routerLink: '/blog' },
        { label: 'FAQ', routerLink: '/faq' },
        { label: 'Explore Jobs', routerLink: '/jobs' }
      ]
    },
    {
      title: 'Quick Links',
      items: [
        { label: 'My Jobs', routerLink: '/my-jobs' },
        { label: 'Explore Jobs', routerLink: '/jobs' },
        { label: 'My Earning', routerLink: '/my-earning' },
        { label: 'My Account', routerLink: '/account' }
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Report a problem' },
        { label: 'Contact Us', routerLink: '/contact' },
        { label: 'FAQ', routerLink: '/faq' },
        { label: 'Terms & Conditions', routerLink: '/terms' },
        { label: 'Privacy Policy', routerLink: '/privacy' }
      ]
    }
  ];
 constructor(injector: Injector) {
    super(injector);

    // subscribe to the same profileDetails stream as header
    this._authService.profileDetails
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe((res: LoginResponse | null) => {
        if (res) {
          const profileData = (res as LoginResponse).data
            ? (res as any).data
            : res;

          this.profile.set(profileData);
          const role = profileData.role;
          this._userType = this.mapRoleToUserType(role);
          this.setLogoLink();
        }
      });
  }

  ngOnInit(): void {
    // optional: if user refreshes and profileDetails is empty, you can trigger getProfile like header
    if (!this.profile()) {
      this.getProfile();
    }
  }

  private getProfile(): void {
    this._authService
      .getProfile()
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe((res: LoginResponse | null) => {
        if (res) {
          this.profile.set(res);
          this._userType = this.mapRoleToUserType(res.role);
          this.setLogoLink();
          this._authService.profileDetails.next(res);
        }
      });
  }

  private mapRoleToUserType(role: any): UserType | null {
    switch (role) {
      case ROLES.STUDENT:
        return 'student';
      case ROLES.TUTOR:
        return 'tutor';
      case ROLES.BUSINESS_ADMIN:
        return 'business';
      case ROLES.BUSINESS_MEMBER:
        return 'business-member';
      case ROLES.ADMIN:
      case ROLES.SUBADMIN:
        return null;
      default:
        return null;
    }
  }

  private setLogoLink(): void {
    if (this._userType === 'student') {
      this.logoLink = '/student-dashboard';
    } else if (this._userType === 'business') {
      this.logoLink = '/business/dashboard';
    } else if (this._userType === 'tutor') {
      this.logoLink = '/tutor/dashboard';
    } else {
      this.logoLink = '/';
    }
  }

  handleToggle(index: number) {
    this.activeIndex = (this.activeIndex === index) ? null : index;
  }
}
